export const getCompanyId = ({ companyId, id }) => companyId || id || null;
export const getCompanyName = ({ companyName, name }) => companyName || name || '';
